import { get, post } from "../../config/api";
import { SERVER_URL } from "../../config/app.config";
class XookService {       

    static async getLinkedKiosks() {
        const url = SERVER_URL + `/v1/admin/restaurant/link`;
        return await get({ url });
    }

}

export default XookService;